import { apiGetFile, GetReportRequest } from 'api';

export const getExtensionRequestsReportCsv = (request: GetReportRequest): Promise<Blob> =>
  apiGetFile('reports/extensionrequests/csv', request);
